export class MedicineForListModel {
    public medicineId: number;
    public brandName: string;
    public medicineNumber: string;
    public additionalTitle: string;
    public medicineHistoryCount: number;
    public hasActiveHistory: boolean;
    public activeIngredientName: string;
}